// Extraction copies the order number into ref_number so the planner and stats
// can read it there. That copy is not a reference the document printed, so a
// screen showing "Reference" must not repeat it (wmtransport read it as one).
export const printedRef = (
  ref: string | undefined,
  ...orderNumbers: (string | undefined)[]
): string | undefined => (ref && !orderNumbers.includes(ref) ? ref : undefined)
